// extracted by mini-css-extract-plugin
export default {"OffersBox":"Offers_OffersBox__0npXW","slides":"Offers_slides__RN5H6","RightArrow":"Offers_RightArrow__9J3j7","LeftArrow":"Offers_LeftArrow__pcnds"};